module.exports = __webpack_public_path__ + "static/media/SOFT TISSUE 8.22ab3ecc.jpg";